import Vuex from 'vuex'
import Vue from 'vue'
import authModule from './modules/auth'
import customerModule from './modules/customer'
import ssoModule from './modules/sso'
import magicModule from './modules/magic'
import configModule from './modules/config'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules : {
        auth: authModule,
        customer: customerModule,
        sso: ssoModule,
        carpet: magicModule,
        config: configModule
    }
})

export default store